import { Component, OnInit, ViewChild } from '@angular/core';
import { AppService, CoreTypes, LabelValue } from 'common-cloudstudio';
import { TableConfig } from './table/table.component';
import { ApolusProxyService, ApolusTypes } from 'src/app/customer-modules/apolus/shared/services/apolus-proxy.service';
import { Observable } from 'rxjs';
import { ApolusService } from 'src/app/customer-modules/apolus/shared/services/apolus.service';
import { GearAppService } from 'common-gear';
import { ModalBatchDevicesComponent } from './modal-batch-devices/modal-batch-devices.component';

interface BaseItem {
  id: number;
  clientId: string;
  contrato: string;
  nombre: string;
  domicilio: string;
  ultimaActualizacion: string;
  selected: boolean;
}

interface EndpointItem extends BaseItem {
  lectura: string;
  estadoEndpoint: string;
}

interface DeviceItem extends BaseItem {
  fechaInstalacion: string;
  estadoDevice: string;
}

interface AlarmaItem extends BaseItem {
  alerta: string;
  estado: string;
}

@Component({
  selector: 'app-actions',
  templateUrl: './actions.component.html',
  styleUrls: ['./actions.component.scss']
})
export class ActionsComponent implements OnInit {
  pendingMassAction: any = null;
  @ViewChild('actionConfirmModal') _actionConfirmModal: any;
  @ViewChild('modalBatchDevices') _modalBatchDevices: ModalBatchDevicesComponent;
  activeTab = 1;
  Math = Math;

  // Configuración de paginación
  itemsPerPage = 10;
  currentPage = 1;
  itemsPerPageOptions = [5, 10, 25, 50];

  // Columnas para cada tabla
  endpointColumns = [
    { name: 'Client ID', property: 'clientId', sortable: true },
    { name: 'No. Contrato', property: 'contrato', sortable: true },
    { name: 'Nombre', property: 'nombre', sortable: true },
    { name: 'Domicilio', property: 'domicilio', sortable: true },
    { name: 'Lectura', property: 'lectura', sortable: true },
    { 
      name: 'Estado', 
      property: 'estadoEndpoint', 
      sortable: true,
      renderer: 'badge',
      badgeConfig: {
        values: {
          'abierta': { class: 'badge-success', icon: 'fa-check' },
          'cerrada': { class: 'badge-danger', icon: 'fa-times' },
          'parcial': { class: 'badge-warning', icon: 'fa-adjust' }
        }
      }
    },
    { name: 'Última Actualización', property: 'ultimaActualizacion', sortable: true }
  ];

  deviceColumns = [
    { name: 'Client ID', property: 'clientId', sortable: true },
    { name: 'No. Contrato', property: 'contrato', sortable: true },
    { name: 'Nombre', property: 'nombre', sortable: true },
    { name: 'Domicilio', property: 'domicilio', sortable: true },
    { name: 'Fecha de Instalación', property: 'fechaInstalacion', sortable: true },
    { 
      name: 'Estado', 
      property: 'estadoDevice', 
      sortable: true,
      renderer: 'badge',
      badgeConfig: {
        values: {
          'activo': { class: 'badge-success', icon: 'fa-check' },
          'inactivo': { class: 'badge-danger', icon: 'fa-times' },
          'parcial': { class: 'badge-warning', icon: 'fa-adjust' }
        }
      }
    },
    { name: 'Última Actualización', property: 'ultimaActualizacion', sortable: true }
  ];

  alarmaColumns = [
    { name: 'Client ID', property: 'clientId', sortable: true },
    { name: 'No. Contrato', property: 'contrato', sortable: true },
    { name: 'Nombre', property: 'nombre', sortable: true },
    { name: 'Domicilio', property: 'domicilio', sortable: true },
    { name: 'Alerta', property: 'alerta', sortable: true },
    { 
      name: 'Estado', 
      property: 'estado', 
      sortable: true,
      renderer: 'badge',
      badgeConfig: {
        values: {
          'activa': { class: 'badge-danger', icon: 'fa-exclamation-triangle' },
          'inactiva': { class: 'badge-success', icon: 'fa-check' },
          'parcial': { class: 'badge-warning', icon: 'fa-adjust' }
        }
      }
    },
    { name: 'Última Actualización', property: 'ultimaActualizacion', sortable: true }
  ];

  // Datos harcodeados para Endpoints
  endpoints: EndpointItem[] = [
    {
      id: 1,
      clientId: 'CLI001',
      contrato: 'CTO001',
      nombre: 'Cliente 1',
      domicilio: 'Calle 1 #123',
      lectura: '100 L',
      estadoEndpoint: 'Abierta',
      ultimaActualizacion: '2024-03-20 10:00',
      selected: false
    },
    {
      id: 2,
      clientId: 'CLI002',
      contrato: 'CTO002',
      nombre: 'Cliente 2',
      domicilio: 'Calle 2 #456',
      lectura: '150 L',
      estadoEndpoint: 'Cerrada',
      ultimaActualizacion: '2024-03-20 09:30',
      selected: false
    }
  ];

  // Datos harcodeados para Devices
  devices: DeviceItem[] = [
    {
      id: 1,
      clientId: 'CLI001',
      contrato: 'CTO001',
      nombre: 'Cliente 1',
      domicilio: 'Calle 1 #123',
      fechaInstalacion: '2024-01-15',
      estadoDevice: 'Activo',
      ultimaActualizacion: '2024-03-20 10:00',
      selected: false
    },
    {
      id: 2,
      clientId: 'CLI002',
      contrato: 'CTO002',
      nombre: 'Cliente 2',
      domicilio: 'Calle 2 #456',
      fechaInstalacion: '2024-02-20',
      estadoDevice: 'Inactivo',
      ultimaActualizacion: '2024-03-20 09:30',
      selected: false
    }
  ];

  // Datos harcodeados para Alarmas
  alarmas: AlarmaItem[] = [
    {
      id: 1,
      clientId: 'CLI001',
      contrato: 'CTO001',
      nombre: 'Cliente 1',
      domicilio: 'Calle 1 #123',
      alerta: 'Alta Presión',
      estado: 'Activa',
      ultimaActualizacion: '2024-03-20 10:00',
      selected: false
    },
    {
      id: 2,
      clientId: 'CLI002',
      contrato: 'CTO002',
      nombre: 'Cliente 2',
      domicilio: 'Calle 2 #456',
      alerta: 'Baja Presión',
      estado: 'Inactiva',
      ultimaActualizacion: '2024-03-20 09:30',
      selected: false
    }
  ];

  // Variables para control de selección
  selectAllEndpoint = false;
  selectAllDevice = false;
  selectAllAlarmas = false;

  // Arrays para elementos seleccionados
  selectedEndpoints: EndpointItem[] = [];
  selectedDevices: DeviceItem[] = [];
  selectedAlarmas: AlarmaItem[] = [];

  endpointTableConfig: TableConfig = {
    type: 'endpoint',
    idField: 'id',
    itemsPerPageOptions: [5, 10, 25, 50],
    defaultItemsPerPage: 10,
    stateSummary: [],
    actions: [
      {
        id: 'abrir',
        label: 'Abrir',
        icon: 'fa fa-faucet',
        iconClass: 'text-success',
        action: (item: EndpointItem) => {
          item.estadoEndpoint = 'Abierta';
          this.updateEndpointSelection(this.endpoints);
        },
        isAvailable: (item: EndpointItem) => item.estadoEndpoint.toLowerCase() === 'cerrada'
      },
      {
        id: 'cerrar',
        label: 'Cerrar',
        icon: 'fa fa-faucet-drip',
        iconClass: 'text-danger',
        action: (item: EndpointItem) => {
          item.estadoEndpoint = 'Cerrada';
          this.updateEndpointSelection(this.endpoints);
        },
        isAvailable: (item: EndpointItem) => item.estadoEndpoint.toLowerCase() === 'abierta'
      },
      {
        id: 'parcial',
        label: 'Parcial',
        icon: 'fa fa-faucet',
        iconClass: 'text-warning',
        action: (item: EndpointItem) => {
          item.estadoEndpoint = 'Parcial';
          this.updateEndpointSelection(this.endpoints);
        },
        isAvailable: (item: EndpointItem) => item.estadoEndpoint.toLowerCase() !== 'parcial'
      }
    ],
    massActions: [
      {
        id: 'abrir-masivo',
        label: 'Abrir',
        icon: 'fa fa-faucet',
        iconClass: 'text-success',
        action: (items: EndpointItem[]) => {
          items.forEach(item => item.estadoEndpoint = 'Abierta');
          this.updateEndpointSelection(this.endpoints);
        },
        confirmMessage: '¿Estás seguro de que deseas abrir los endpoints?',
        confirmIcon: 'fa fa-faucet'
      },
      {
        id: 'cerrar-masivo',
        label: 'Cerrar',
        icon: 'fa fa-faucet-drip',
        iconClass: 'text-danger',
        action: (items: EndpointItem[]) => {
          items.forEach(item => item.estadoEndpoint = 'Cerrada');
          this.updateEndpointSelection(this.endpoints);
        },
        confirmMessage: '¿Estás seguro de que deseas cerrar los endpoints seleccionados?',
        confirmIcon: 'fa fa-faucet-drip'
      },
      {
        id: 'parcial-masivo',
        label: 'Parcial',
        icon: 'fa fa-faucet',
        iconClass: 'text-warning',
        action: (items: EndpointItem[]) => {
          items.forEach(item => item.estadoEndpoint = 'Parcial');
          this.updateEndpointSelection(this.endpoints);
        },
        confirmMessage: '¿Estás seguro de que deseas abrir parcialmente los endpoints seleccionados?',
        confirmIcon: 'fa fa-faucet'
      }
    ]
  };

  deviceTableConfig: TableConfig = {
    type: 'device',
    idField: 'id',
    itemsPerPageOptions: [5, 10, 25, 50],
    defaultItemsPerPage: 10,
    stateSummary: [],
    actions: [
      {
        id: 'activar',
        label: 'Activar',
        icon: 'fa fa-power-off',
        iconClass: 'text-success',
        action: (item: DeviceItem) => {
          item.estadoDevice = 'Activo';
          this.updateDeviceSelection(this.devices);
        },
        isAvailable: (item: DeviceItem) => item.estadoDevice.toLowerCase() === 'inactivo'
      },
      {
        id: 'desactivar',
        label: 'Desactivar',
        icon: 'fa fa-power-off',
        iconClass: 'text-danger',
        action: (item: DeviceItem) => {
          item.estadoDevice = 'Inactivo';
          this.updateDeviceSelection(this.devices);
        },
        isAvailable: (item: DeviceItem) => item.estadoDevice.toLowerCase() === 'activo'
      },
      {
        id: 'parcial',
        label: 'Modo Parcial',
        icon: 'fa fa-power-off',
        iconClass: 'text-warning',
        action: (item: DeviceItem) => {
          item.estadoDevice = 'Parcial';
          this.updateDeviceSelection(this.devices);
        },
        isAvailable: (item: DeviceItem) => item.estadoDevice.toLowerCase() !== 'parcial'
      }
    ],
    massActions: [
      {
        id: 'activar-masivo',
        label: 'Activar',
        icon: 'fa fa-power-off',
        iconClass: 'text-success',
        action: (items: DeviceItem[]) => {
          items.forEach(item => item.estadoDevice = 'Activo');
          this.updateDeviceSelection(this.devices);
        },
        confirmMessage: '¿Estás seguro de que deseas activar los devices seleccionados?',
        confirmIcon: 'fa fa-power-off'
      },
      {
        id: 'desactivar-masivo',
        label: 'Desactivar',
        icon: 'fa fa-power-off',
        iconClass: 'text-danger',
        action: (items: DeviceItem[]) => {
          items.forEach(item => item.estadoDevice = 'Inactivo');
          this.updateDeviceSelection(this.devices);
        },
        confirmMessage: '¿Estás seguro de que deseas desactivar los devices seleccionados?',
        confirmIcon: 'fa fa-power-off'
      },
      {
        id: 'parcial-masivo',
        label: 'Modo Parcial',
        icon: 'fa fa-power-off',
        iconClass: 'text-warning',
        action: (items: DeviceItem[]) => {
          items.forEach(item => item.estadoDevice = 'Parcial');
          this.updateDeviceSelection(this.devices);
        },
        confirmMessage: '¿Estás seguro de que deseas poner en modo parcial los devices seleccionados?',
        confirmIcon: 'fa fa-power-off'
      }
    ]
  };

  alarmaTableConfig: TableConfig = {
    type: 'alarma',
    idField: 'id',
    itemsPerPageOptions: [5, 10, 25, 50],
    defaultItemsPerPage: 10,
    stateSummary: [],
    actions: [
      {
        id: 'activar',
        label: 'Activar',
        icon: 'fa fa-bell',
        iconClass: 'text-warning',
        action: (item: AlarmaItem) => {
          item.estado = 'Activa';
          this.updateAlarmaSelection(this.alarmas);
        },
        isAvailable: (item: AlarmaItem) => item.estado.toLowerCase() === 'inactiva'
      },
      {
        id: 'desactivar',
        label: 'Desactivar',
        icon: 'fa fa-bell-slash',
        iconClass: 'text-success',
        action: (item: AlarmaItem) => {
          item.estado = 'Inactiva';
          this.updateAlarmaSelection(this.alarmas);
        },
        isAvailable: (item: AlarmaItem) => item.estado.toLowerCase() === 'activa'
      },
      {
        id: 'parcial',
        label: 'Modo Parcial',
        icon: 'fa fa-bell',
        iconClass: 'text-warning',
        action: (item: AlarmaItem) => {
          item.estado = 'Parcial';
          this.updateAlarmaSelection(this.alarmas);
        },
        isAvailable: (item: AlarmaItem) => item.estado.toLowerCase() !== 'parcial'
      }
    ],
    massActions: [
      {
        id: 'activar-masivo',
        label: 'Activar',
        icon: 'fa fa-bell',
        iconClass: 'text-warning',
        action: (items: AlarmaItem[]) => {
          items.forEach(item => item.estado = 'Activa');
          this.updateAlarmaSelection(this.alarmas);
        },
        confirmMessage: '¿Estás seguro de que deseas activar las alarmas seleccionadas?',
        confirmIcon: 'fa fa-bell'
      },
      {
        id: 'desactivar-masivo',
        label: 'Desactivar',
        icon: 'fa fa-bell-slash',
        iconClass: 'text-success',
        action: (items: AlarmaItem[]) => {
          items.forEach(item => item.estado = 'Inactiva');
          this.updateAlarmaSelection(this.alarmas);
        },
        confirmMessage: '¿Estás seguro de que deseas desactivar las alarmas seleccionadas?',
        confirmIcon: 'fa fa-bell-slash'
      },
      {
        id: 'parcial-masivo',
        label: 'Modo Parcial',
        icon: 'fa fa-bell',
        iconClass: 'text-warning',
        action: (items: AlarmaItem[]) => {
          items.forEach(item => item.estado = 'Parcial');
          this.updateAlarmaSelection(this.alarmas);
        },
        confirmMessage: '¿Estás seguro de que deseas poner en modo parcial las alarmas seleccionadas?',
        confirmIcon: 'fa fa-bell'
      }
    ]
  };
  searchText = '';
  sectorList: LabelValue<number>[] = [];
  sector: LabelValue<number> = null;
  localityList: LabelValue<number>[] = [];
  locality: LabelValue<number> = null;
  _sectorsFullList: ApolusTypes.Sector[] = [];
  addressList: LabelValue<number>[] = [];
  address: LabelValue<number> = null;
  streetNumberList: LabelValue<string>[] = [];
  streetNumber: LabelValue<string> = null;

  constructor(
    public _appService: AppService,
    public _apolusProxyService: ApolusProxyService,
    public apolusService: ApolusService,
    public gearAppService: GearAppService
  ) { }

  ngOnInit(): void {
    this.initializeData();
  }

  initializeData() {
    this.getSectorsList().subscribe(() => {
      this.getAddressesList().subscribe(() => {
        console.log('Data initialized');
      });
    });
  }

  toggleSelectAllEndpoint(checked?: boolean): void {
    if (typeof checked === 'boolean') {
      this.selectAllEndpoint = checked;
      this.endpoints.forEach(item => item.selected = checked);
      this.updateEndpointSelection();
    } else if (Array.isArray(checked)) {
      // Si viene un array (del itemSelectionChange), actualizar la lista
      this.endpoints = checked;
      this.updateEndpointSelection();
    }
  }

  updateEndpointSelection(event?: any): void {
    if (Array.isArray(event)) {
      this.endpoints = event;
    }
    if (Array.isArray(this.endpoints)) {
      this.selectedEndpoints = this.endpoints.filter(item => item.selected);
      this.selectAllEndpoint = this.endpoints.length > 0 && this.endpoints.every(item => item.selected);
    } else {
      this.selectedEndpoints = [];
      this.selectAllEndpoint = false;
    }
    this.updateStateSummary('endpoint');
  }

  toggleSelectAllAlarmas(checked?: boolean): void {
    if (typeof checked === 'boolean') {
      this.selectAllAlarmas = checked;
      this.alarmas.forEach(item => item.selected = checked);
      this.updateAlarmaSelection();
    } else if (Array.isArray(checked)) {
      // Si viene un array (del itemSelectionChange), actualizar la lista
      this.alarmas = checked;
      this.updateAlarmaSelection();
    }
  }

  updateAlarmaSelection(event?: any): void {
    if (Array.isArray(event)) {
      this.alarmas = event;
    }
    if (Array.isArray(this.alarmas)) {
      this.selectedAlarmas = this.alarmas.filter(item => item.selected);
      this.selectAllAlarmas = this.alarmas.length > 0 && this.alarmas.every(item => item.selected);
    } else {
      this.selectedAlarmas = [];
      this.selectAllAlarmas = false;
    }
    this.updateStateSummary('alarma');
  }

  toggleSelectAllDevice(checked?: boolean): void {
    if (typeof checked === 'boolean') {
      this.selectAllDevice = checked;
      this.devices.forEach(item => item.selected = checked);
      this.updateDeviceSelection();
    } else if (Array.isArray(checked)) {
      // Si viene un array (del itemSelectionChange), actualizar la lista
      this.devices = checked;
      this.updateDeviceSelection();
    }
  }

  updateDeviceSelection(event?: any): void {
    if (Array.isArray(event)) {
      this.devices = event;
    }
    if (Array.isArray(this.devices)) {
      this.selectedDevices = this.devices.filter(item => item.selected);
      this.selectAllDevice = this.devices.length > 0 && this.devices.every(item => item.selected);
    } else {
      this.selectedDevices = [];
      this.selectAllDevice = false;
    }
    this.updateStateSummary('device');
  }

  updateStateSummary(type: 'endpoint' | 'alarma' | 'device'): void {
    let items: any[];
    let stateProperty: string;

    switch (type) {
      case 'endpoint':
        items = this.selectedEndpoints;
        stateProperty = 'estadoEndpoint';
        break;
      case 'alarma':
        items = this.selectedAlarmas;
        stateProperty = 'estado';
        break;
      case 'device':
        items = this.selectedDevices;
        stateProperty = 'estadoDevice';
        break;
    }

    const stateCount = new Map<string, number>();
    items.forEach(item => {
      const state = item[stateProperty].toLowerCase();
      stateCount.set(state, (stateCount.get(state) || 0) + 1);
    });

    const summary = Array.from(stateCount.entries()).map(([state, count]) => ({
      state: state.charAt(0).toUpperCase() + state.slice(1),
      count
    }));

    switch (type) {
      case 'endpoint':
        this.endpointTableConfig.stateSummary = summary;
        break;
      case 'alarma':
        this.alarmaTableConfig.stateSummary = summary;
        break;
      case 'device':
        this.deviceTableConfig.stateSummary = summary;
        break;
    }
  }

  getPaginatedEndpoints(): EndpointItem[] {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    return this.endpoints.slice(startIndex, startIndex + this.itemsPerPage);
  }

  getPaginatedDevices(): DeviceItem[] {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    return this.devices.slice(startIndex, startIndex + this.itemsPerPage);
  }

  getPaginatedAlarmas(): AlarmaItem[] {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    return this.alarmas.slice(startIndex, startIndex + this.itemsPerPage);
  }

  getTotalPages(items: any[]): number {
    return Math.ceil(items.length / this.itemsPerPage);
  }

  onPageChange(page: number): void {
    this.currentPage = page;
  }

  onItemsPerPageChange(): void {
    this.currentPage = 1;
  }

  emitChangeParam(event: any): void {
    console.log('emitChangeParam', event);
  }

  onLoadEndpointList(): void {
    // Implementar lógica para cargar lista de endpoints
  }

  onLoadDeviceList(): void {
    // Implementar lógica para cargar lista de devices
  }

  onLoadAlarmaList(): void {
    // Implementar lógica para cargar lista de alarmas
  }

  getTotalItemsCount(): number {
    switch (this.activeTab) {
      case 1: return this.endpoints.length;
      case 2: return this.alarmas.length;
      case 3: return this.devices.length;
      default: return 0;
    }
  }

  getSelectedItemsCount(): number {
    switch (this.activeTab) {
      case 1: return this.selectedEndpoints.length;
      case 2: return this.selectedAlarmas.length;
      case 3: return this.selectedDevices.length;
      default: return 0;
    }
  }

  onLoadCurrentTabList(): void {
    if (this._modalBatchDevices) {
      this._modalBatchDevices.openModal(this.activeTab);
    }
  }

  onDevicesLoaded(deviceIds: number[]): void {
    switch (this.activeTab) {
      case 1:
        this.selectDevicesInList(this.endpoints, deviceIds);
        break;
      case 2:
        this.selectDevicesInList(this.alarmas, deviceIds);
        break;
      case 3:
        this.selectDevicesInList(this.devices, deviceIds);
        break;
    }
  }

  private selectDevicesInList(items: any[], deviceIds: number[]): void {
    items.forEach(item => {
      if (deviceIds.includes(item.id)) {
        item.selected = true;
      }
    });
    
    switch (this.activeTab) {
      case 1:
        this.updateEndpointSelection(this.endpoints);
        break;
      case 2:
        this.updateAlarmaSelection(this.alarmas);
        break;
      case 3:
        this.updateDeviceSelection(this.devices);
        break;
    }
  }

  getCurrentTabMassActions(): any[] {
    switch (this.activeTab) {
      case 1: return this.endpointTableConfig.massActions || [];
      case 2: return this.alarmaTableConfig.massActions || [];
      case 3: return this.deviceTableConfig.massActions || [];
      default: return [];
    }
  }

  initiateMassAction(action: any): void {
    const selectedItems = this.getCurrentTabSelectedItems();
    if (selectedItems.length === 0) {
      return;
    }

    if (action.confirmMessage) {
      this.pendingMassAction = action;
      this._actionConfirmModal.open();
    } else {
      this.executeMassAction(action);
    }
  }

  getCurrentTabSelectedItems(): any[] {
    switch (this.activeTab) {
      case 1: return this.selectedEndpoints;
      case 2: return this.selectedAlarmas;
      case 3: return this.selectedDevices;
      default: return [];
    }
  }

  clearCurrentTabSelection(): void {
    switch (this.activeTab) {
      case 1: 
        this.selectedEndpoints = [];
        this.selectAllEndpoint = false;
        this.endpoints.forEach(item => item.selected = false);
        break;
      case 2: 
        this.selectedAlarmas = [];
        this.selectAllAlarmas = false;
        this.alarmas.forEach(item => item.selected = false);
        break;
      case 3: 
        this.selectedDevices = [];
        this.selectAllDevice = false;
        this.devices.forEach(item => item.selected = false);
        break;
    }
  }

  executeMassAction(action: any): void {
    const selectedItems = this.getCurrentTabSelectedItems();
    action.action(selectedItems);
    this._actionConfirmModal.close();
    this.pendingMassAction = null;
    this.clearCurrentTabSelection();
  }

  cancelMassAction(): void {
    this._actionConfirmModal.close();
    this.pendingMassAction = null;
  }

  addNewDevices() {

  }

  search(event: any): void {
    console.log('search', event);
  }

  getSectorsList(): Observable<any> {
    return new Observable(observer => {
      this._apolusProxyService.ApolusService.EnumSectors(
        this._appService.getAccessToken(),
        (data: ApolusTypes.Sector[]) => {
          this._sectorsFullList = data;
          let items: LabelValue<number>[] = [];
          data.forEach((x, i) => {
            let item = {
              label: x.Description,
              value: x.SectorID
            };
            items.push(item);
          });
          this.sectorList = items;
          this.sector = this.sectorList[0];
          observer.next(true);
          observer.complete();
        },
        (err) => {
          this._appService.showException(err);
          observer.error(err);
        }
      );
    });
  }

  getAddressesList(): Observable<any> {
    return new Observable(observer => {
      this._apolusProxyService.ApolusService.EnumGeocodingAddresses(
        this._appService.getAccessToken(),
        (data: ApolusTypes.GeocodingAddress[]) => {
          let items: LabelValue<number>[] = [];
          let addresses: LabelValue<number>[] = [];
          let streetNumbers: LabelValue<string>[] = [];
          data.forEach((x, i) => {
            let item = {
              label: x.StreetName + ' ' + x.StreetNumber,
              value: x.AdminArea2ID
            };
            let address = {
              label: x.StreetName,
              value: x.AdminArea2ID
            };
            let streetNumber = {
              label: x.StreetNumber,
              value: x.StreetNumber
            };
            streetNumbers.push(streetNumber);
            addresses.push(address);
            items.push(item);
          });
          this.localityList = items;
          this.locality = this.localityList[0];
          this.addressList = addresses;
          this.address = this.addressList[0];
          this.streetNumberList = streetNumbers;
          this.streetNumber = this.streetNumberList[0];
          observer.complete();
        },
        (err) => {
          this._appService.showException(err);
          observer.error(err);
        }
      );
    });
  }
}
